import { InMessageTopic } from 'embedded/api/in/InMessageTopic';
import { AnyAction, Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';
import { logoutAction } from 'login/store/thunks';
import { AppMode } from 'app/store/general/AppMode';
import { ThunkDispatch } from 'store/store';
import {
    LogoutMessagePayload,
    logoutPayloadSchema,
} from 'embedded/api/in/messages/LogoutMessagePayload';

export class LogoutMessage extends InMessageTopic<LogoutMessagePayload> {
    public constructor() {
        super(logoutPayloadSchema, {
            supportedAppModes: [
                AppMode.EMBEDDED_SINGLE_WIDGET,
                AppMode.EMBEDDED_DASHBOARD,
            ],
            mustBeAuthenticated: false,
        });
    }

    public handle(
        uid: string,
        payload: LogoutMessagePayload,
        store: Store,
        _loggingService: LoggingService
    ): void {
        const dispatch = store.dispatch as ThunkDispatch<AnyAction>;
        dispatch(logoutAction());
    }
}
